import React, { useState } from "react";
import { db } from "../firebase";
import { collection, addDoc } from "firebase/firestore";
import { motion } from "framer-motion";

const Ask = () => {
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [details, setDetails] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!name.trim() || !phone.trim() || !details.trim()) {
      setError("❌ من فضلك املأ جميع الحقول");
      return;
    }

    const phoneRegex = /^[0-9]{10,15}$/;
    if (!phoneRegex.test(phone)) {
      setError("❌ من فضلك أدخل رقم تليفون صحيح");
      return;
    }

    setError("");
    try {
      await addDoc(collection(db, "consultations"), {
        name,
        phone,
        details,
        createdAt: new Date(),
      });
      setSuccess("✅ تم إرسال الاستشارة بنجاح");
      setName("");
      setPhone("");
      setDetails("");
    } catch (err) {
      setError("⚠️ حدث خطأ أثناء الحفظ، حاول مرة أخرى");
    }
  };

  return (
    <section
      className="ask-section"
      style={{
        padding: "80px 0",
        backgroundColor: "#fdfdfd",
        color: "#222",
      }}
    >
      <div
        className="container"
        style={{
          width: "90%",
          maxWidth: "1100px",
          margin: "0 auto",
        }}
      >
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          style={{
            textAlign: "center",
            marginBottom: "50px",
          }}
        >
          <h2
            style={{
              fontSize: "2rem",
              fontWeight: "700",
              color: "#29521e",
              letterSpacing: "1px",
            }}
          >
            استشارات قانونية
          </h2>
          <p style={{ color: "#666", marginTop: "10px", fontSize: "1rem" }}>
            أرسل استشارتك القانونية وسيتواصل معك أحد المتخصصين في أقرب وقت
          </p>
        </motion.div>

        <div
          className="mainContent"
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "40px",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <motion.div
            initial={{ opacity: 0, x: -80 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            style={{
              flex: "1 1 350px",
              textAlign: "center",
            }}
          >
            <img
              src="https://res.cloudinary.com/defcamc5x/image/upload/v1761944550/jr3a9kh2cncjz7nba9x2.png"
              alt="استشارة قانونية"
              style={{
                maxWidth: "90%",
                height: "auto",
                borderRadius: "20px",
                margin:"auto",
              }}
            />
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 80 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            style={{
              flex: "1 1 400px",
              background: "#f8f8f8",
              padding: "40px 30px",
              borderRadius: "20px",
              boxShadow: "0 8px 25px rgba(0,0,0,0.08)",
              border: "1px solid #eee",
            }}
          >
            <form
              onSubmit={handleSubmit}
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "15px",
              }}
            >
              {error && (
                <p style={{ color: "#c0392b", textAlign: "center" }}>{error}</p>
              )}
              {success && (
                <p style={{ color: "#27ae60", textAlign: "center" }}>
                  {success}
                </p>
              )}

              <label style={{ fontWeight: "600", color: "#333" }}>
                الاسم بالكامل:
              </label>
              <input
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="اكتب اسمك بالكامل"
                style={inputStyle}
              />

              <label style={{ fontWeight: "600", color: "#333" }}>
                رقم التليفون (واتساب):
              </label>
              <input
                type="text"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                placeholder="01xxxxxxxxx"
                style={inputStyle}
              />

              <label style={{ fontWeight: "600", color: "#333" }}>
                تفاصيل الاستشارة:
              </label>
              <textarea
                value={details}
                onChange={(e) => setDetails(e.target.value)}
                placeholder="اكتب تفاصيل استشارتك هنا..."
                style={{
                  ...inputStyle,
                  minHeight: "120px",
                  resize: "vertical",
                }}
              ></textarea>

              <motion.button
                type="submit"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.98 }}
                style={buttonStyle}
                onMouseOver={(e) =>
                  (e.currentTarget.style.background = "#3a7a2b")
                }
                onMouseOut={(e) =>
                  (e.currentTarget.style.background = "#29521e")
                }
              >
                إرسال الاستشارة
              </motion.button>
            </form>
          </motion.div>
        </div>
      </div>

      <style>
        {`
          @media (max-width: 768px) {
            .ask-section {
              padding: 60px 0 !important;
            }
            h2 {
              font-size: 1.6rem !important;
            }
            .mainContent {
              flex-direction: column !important;
            }
            form {
              padding: 25px !important;
            }
          }
        `}
      </style>
    </section>
  );
};

const inputStyle = {
  padding: "12px",
  borderRadius: "8px",
  border: "1px solid #ccc",
  outline: "none",
  fontSize: "16px",
  transition: "0.2s",
  width: "100%",
};

const buttonStyle = {
  background: "#29521e",
  padding: "14px",
  color: "#fff",
  fontWeight: "bold",
  fontSize: "17px",
  borderRadius: "10px",
  border: "none",
  cursor: "pointer",
  transition: "0.3s",
  letterSpacing: "0.5px",
};

export default Ask;
